import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import { AuthProvider } from "@/dashboard/AuthContext";
import Login from "@/dashboard/Login";
import DashboardLayout from "@/dashboard/DashboardLayout";
import Overview from "@/dashboard/pages/Overview";
import SendMessages from "@/dashboard/pages/SendMessages";
import Inbox from "@/dashboard/pages/Inbox";
import Settings from "@/dashboard/pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public marketing site */}
            <Route
              path="/"
              element={
                <SmoothScroll>
                  <Home />
                </SmoothScroll>
              }
            />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* Internal dashboard */}
            <Route path="/dashboard/login" element={<Login />} />
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<Overview />} />
              <Route path="send" element={<SendMessages />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </AuthProvider>
        <Toaster position="bottom-right" theme="light" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
